import * as React from "react";
import { Button } from '../button/button'
import { Input } from '../input/input'
import './modalBlockEmail.css'
import axiosInstance from "../../auth/axiosInstance";
import { useMsal } from "@azure/msal-react";
import { UseOnChange } from "../../utils/onChange";

export const ModalBlock = (props) => {

    const { values, onChange } = UseOnChange()
    const [site, setSite] = React.useState([])

    React.useEffect(() => {
        const getData = () => {
            axiosInstance('sites')
                .then((res) => {
                    setSite(res.data)
                })
                .catch((err) => console.log(err));
        }

        getData()
    }, [])

    const { accounts } = useMsal()

    function postLog(text) {
        axiosInstance.post('logs', {
            email: accounts[0].username,
            name: accounts[0].name,
            action: text
        })
            .catch(err => console.log(err))
    }

    function cadastrar(e) {
        e.preventDefault();
        axiosInstance.post(`access-control/`, { emailColab: values.email, Type: values.Type, Site: !!values?.Site ? values.Site : 'Admin' })
            .then((res) => {
                postLog(`Access Control created to ${values.email}`)
                if (res.status === 201) {
                    props.feedback(true);
                    props.typeRequest(1);
                    props.reload(true);
                    props.set(false)
                    setTimeout(() => {
                        props.feedback(false);
                    }, 10000);
                }
            })
            .catch((err) => {
                console.log(err);
                props.feedback(true);
                props.typeRequest(3);
                props.reload(true);
                setTimeout(() => {
                    props.feedback(false);
                }, 10000);
            });
    }

    return (
        <section style={{ display: props.show ? 'flex' : 'none' }} className='content-block-email-modal-block'>
            <form onSubmit={(e) => cadastrar(e)} className='content-block-email-modal-block_form'>
                <h1>Add E-Mail</h1>
                <Input name='email' type={'email'} id='email-blacklist' onChange={onChange} placeholder='name@scaladatacenters.com' title='E-Mail' />
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 15, margin: 0 }}>
                    <h2 style={{ fontSize: 16, fontWeight: 600 }}>Access Type:</h2>
                    <div style={{ display: 'flex', gap: 15 }}>
                        <Input onChange={onChange} checked={values.Type === 'Admin'} name='Type' value='Admin' type='radio' label='Admin' props={{ width: 15, height: 15 }} />
                        <Input onChange={onChange} checked={values.Type === 'View Only'} name='Type' value='View Only' type='radio' label='View Only' props={{ width: 15, height: 15 }} />
                        <Input onChange={onChange} checked={values.Type === 'Site'} name='Type' value='Site' type='radio' label='Site' props={{ width: 15, height: 15 }} />
                    </div>
                </div>
                {
                    (!!values?.Type && values.Type === 'Site') &&
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 5, margin: '10px 0' }}>
                        <h2 style={{ fontSize: 16, fontWeight: 600 }}>Select a site:</h2>
                        <div style={{ display: 'flex', gap: 15 }}>
                            {
                                site.map(val => {
                                    return (
                                        <Input onChange={onChange} name='Site' value={val.site} type='radio' label={val.site} props={{ width: 15, height: 15 }} />
                                    )
                                })
                            }
                        </div>
                    </div>
                }
                <div className='content-button-areas'>
                    <Button typeButton='button' style={{ background: 'transparent', color: '#0F0742' }} onClick={() => props.set(false)} label='Cancel' />
                    <Button disabled={!!values?.Type ? values.Type === 'Site' ? Object.keys(values).length < 3 || Object.values(values).includes('') : Object.keys(values).length < 2 || Object.values(values).includes('') : true} typeButton='submit' label='Save' />
                </div>
            </form>
        </section>
    )
}